import type { PlatformAdapter, PayResult } from './types';

/** Минимальная типизация window.Telegram.WebApp (только используемое). */
interface TgWebApp {
  initData: string;
  initDataUnsafe: { start_param?: string; user?: { language_code?: string } };
  ready(): void;
  expand(): void;
  close(): void;
  setHeaderColor(c: string): void;
  setBackgroundColor(c: string): void;
  disableVerticalSwipes?(): void;
  openInvoice(url: string, cb: (status: string) => void): void;
  openTelegramLink(url: string): void;
  openLink(url: string): void;
  showAlert(msg: string): void;
  HapticFeedback: { impactOccurred(s: string): void; notificationOccurred(s: string): void };
  BackButton: { show(): void; hide(): void; onClick(cb: () => void): void; offClick(cb: () => void): void };
}
declare global { interface Window { Telegram?: { WebApp?: TgWebApp } } }

export const telegramWebApp = (): TgWebApp | null => {
  const w = window.Telegram?.WebApp;
  return w && w.initData ? w : null;
};

export class TelegramAdapter implements PlatformAdapter {
  readonly name = 'telegram' as const;
  private back: (() => void) | null = null;

  constructor(private readonly tg: TgWebApp) {
    tg.ready();
    tg.expand();
    try { tg.setHeaderColor('#0f0720'); tg.setBackgroundColor('#0f0720'); tg.disableVerticalSwipes?.(); } catch { /* старые клиенты */ }
  }
  getAuthPayload() { return { provider: 'telegram' as const, initData: this.tg.initData, tzOffset: -new Date().getTimezoneOffset() }; }
  getStartParam() { return this.tg.initDataUnsafe.start_param ?? null; }
  haptic(kind: 'light' | 'medium' | 'heavy' | 'success' | 'error') {
    try {
      if (kind === 'success' || kind === 'error') this.tg.HapticFeedback.notificationOccurred(kind);
      else this.tg.HapticFeedback.impactOccurred(kind);
    } catch { /* нет haptic */ }
  }
  pay(invoiceUrl: string) {
    return new Promise<PayResult>((resolve) => this.tg.openInvoice(invoiceUrl, (s) => resolve(s as PayResult)));
  }
  share(text: string, url?: string) {
    this.tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(url ?? '')}&text=${encodeURIComponent(text)}`);
  }
  openLink(url: string) { this.tg.openLink(url); }
  setBackHandler(cb: (() => void) | null) {
    if (this.back) this.tg.BackButton.offClick(this.back);
    this.back = cb;
    if (cb) { this.tg.BackButton.onClick(cb); this.tg.BackButton.show(); } else this.tg.BackButton.hide();
  }
  getLocale() { return this.tg.initDataUnsafe.user?.language_code ?? 'ru'; }
  close() { this.tg.close(); }
}
